// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_a2-3";
export var contentContainer = "_a2-0";
export var editorContainer = "_a2-1";
export var quillInputForm = "_a2-2";
export var zoneDivider = "_a2-4";